import { ChangeDetectionStrategy, Component, ContentChild, TemplateRef } from '@angular/core'

@Component({
	selector: 'app-table-footer',
	templateUrl: 'table-footer.component.html',
	styleUrl: 'table-footer.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableFooterComponent {
	@ContentChild(TemplateRef) footerTemplate: TemplateRef<unknown> | null = null
}
